import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { MessageProvider } from '@messageformat/react';
import React from 'react';
import { Locale } from '@peloton/internationalize';
import Copy from '@webtv/copy';
import { FullScreenSpinner } from '@webtv/shared-ui';
import { jsx as _jsx } from "react/jsx-runtime";

var fetchData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locale, page, setData, setError) {
    var response, _response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!locale) {
              _context.next = 21;
              break;
            }

            _context.prev = 1;
            _context.next = 4;
            return Copy[page](locale);

          case 4:
            response = _context.sent;
            response && setData(response === null || response === void 0 ? void 0 : response.default);
            _context.next = 21;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            _context.prev = 10;
            _context.next = 13;
            return Copy[page](Locale.EnglishUnitedStates);

          case 13:
            _response = _context.sent;
            _response && setData(_response === null || _response === void 0 ? void 0 : _response.default);
            _context.next = 21;
            break;

          case 17:
            _context.prev = 17;
            _context.t1 = _context["catch"](10);
            console.error('Error fetching Copy page data: ', _context.t0);
            setError(_context.t1);

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8], [10, 17]]);
  }));

  return function fetchData(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

export var CopyProvider = function CopyProvider(_ref2) {
  var children = _ref2.children,
      page = _ref2.page,
      _ref2$showLoadingSpin = _ref2.showLoadingSpinner,
      showLoadingSpinner = _ref2$showLoadingSpin === void 0 ? true : _ref2$showLoadingSpin,
      getLocale = _ref2.getLocale;
  var locale = getLocale();

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      data = _React$useState2[0],
      setData = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      globalData = _React$useState4[0],
      setGlobalData = _React$useState4[1];

  var _React$useState5 = React.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      error = _React$useState6[0],
      setError = _React$useState6[1];

  React.useEffect(function () {
    // load the page specific copy
    fetchData(locale, page, setData, setError); // load the global copy on any page that has a CopyProvider

    fetchData(locale, 'global', setGlobalData, setError);
  }, [locale, page]); // make sure to trigger the ErrorBoundary if the copy file is not found

  if (error) {
    throw new Error(error);
  }

  if (locale && data && globalData) {
    return /*#__PURE__*/_jsx(MessageProvider, {
      locale: locale,
      messages: _objectSpread(_objectSpread({}, data), globalData),
      children: children
    });
  }

  return showLoadingSpinner ? /*#__PURE__*/_jsx(FullScreenSpinner, {}) : null;
};